module.exports = __webpack_public_path__ + "img/1964 bugle- Minstrels _continuing in true southern tradition_.10752951.png";